import { render, staticRenderFns } from "./ArticlesParProduit.vue?vue&type=template&id=34028a52&"
import script from "./ArticlesParProduit.vue?vue&type=script&lang=js&"
export * from "./ArticlesParProduit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports